import * as React from "react"
import cx from "classnames"

import Link from "@components/elements/link"
import { externalRoutes } from "@data/routes"

import LinkedinIcon from "@images/linkedin-icon.inline.svg"
import TwitterIcon from "@images/twitter-icon.inline.svg"
import FacebookIcon from "@images/facebook-icon.inline.svg"

import styles from "./socialLinks.module.scss"

const SocialLinks = ({ className, isCircle }) => {
  return (
    <ul
      className={cx(styles.socialLinks, className, {
        [styles.isCircle]: isCircle,
      })}
    >
      <li>
        <Link
          className={styles.link}
          url={externalRoutes.LINKEDIN}
          aria-label="LinkedIn"
        >
          <LinkedinIcon className={styles.icon} />
        </Link>
      </li>
      <li>
        <Link
          className={styles.link}
          url={externalRoutes.TWITTER}
          aria-label="Twitter"
        >
          <TwitterIcon className={styles.icon} />
        </Link>
      </li>
      <li>
        <Link
          className={styles.link}
          url={externalRoutes.FACEBOOK}
          aria-label="Facebook"
        >
          <FacebookIcon className={styles.icon} />
        </Link>
      </li>
    </ul>
  )
}

export default SocialLinks
